import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import history from 'app/routes/history';
import Button from 'app/components/general/Button';
import { Label, Input } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';

import RightArrow from './right-arrow.svg';


export default class MapFields extends React.Component {
  static propTypes = {
    requiredFields: PropTypes.array,
    defaultMapping: PropTypes.object,
    actions: PropTypes.object,
    availableFields: PropTypes.array,
    exampleRecord: PropTypes.object,
    staticData: PropTypes.object,
    paymentEventImports: PropTypes.object,
    fileContent: PropTypes.string,
  };

  static defaultProps = {
    actions: undefined,
    paymentEventImports: undefined,
    exampleRecord: undefined,
    staticData: undefined,
    fileContent: undefined,
    requiredFields: [
      {
        name: 'Competition Name',
        type: 'event',
        key: 'scheduledPayment.sectionTag',
        required: true,
      },
      {
        name: 'Reference ID',
        type: 'event',
        key: 'scheduledPayment.reference',
        required: true,
      },
      {
        name: 'Description',
        type: 'event',
        key: 'scheduledPayment.description',
        required: true,
      },
      {
        name: 'Event Date',
        type: 'event',
        key: 'scheduledPayment.eventDate',
        required: true,
      },
      {
        name: 'Event Time',
        type: 'event',
        key: 'scheduledPayment.eventTime',
        required: true,
      },
      {
        name: 'Location',
        type: 'event',
        key: 'scheduledPayment.locationInfo',
        required: true,
      },
      {
        name: 'Team 1 Name',
        type: 'event',
        key: 'scheduledPayment.groupOneName',
        required: true,
      },
      {
        name: 'Team 2 Name',
        type: 'event',
        key: 'scheduledPayment.groupTwoName',
        required: false,
      },
    ],
    defaultMapping: {
      sectionName: 'Section Name',
      seasonName: 'Season Name',
      competitionName: 'Competition Name',
      uniqueKey: 'Match ID',
      roundNumber: 'Round Number',
      matchAt: 'Match Date Time',
      team1UniqueKey: 'Team 1 ID',
      team2UniqueKey: 'Team 2 ID',
      team1Name: 'Team 1',
      team2Name: 'Team 2',
      locationName: 'Venue Name',
    },
    availableFields: [],
  };

  state = {
    initialMappingSet: false,
    mapping: {},
  };

  componentDidMount() {
    this.setInitialMapping();
  }

  async componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setInitialMapping();
    }
  }

  setInitialMapping = () => {
    const newMapping = {};
    _.map(this.props.availableFields, (field) => {
      const defaultMapped = this.props.defaultMapping[field];
      if (defaultMapped !== undefined) {
        newMapping[defaultMapped] = {
          id: field,
          name: field,
        };
      }
    });
    this.setState({
      initialMappingSet: true,
      mapping: newMapping,
    });
  };

  checkIfAllMapped = () => {
    let valid = true;
    const requiredMapping = _.filter(this.props.requiredFields, {
      required: true,
    });

    _.map(requiredMapping, (mapping) => {
      if (_.isEmpty(this.state.mapping[mapping.key])) {
        valid = false;
      }
    });
    return valid;
  };

  handleMappingChange = (e, mappingField) => {
    this.setState({ mapping: { ...this.state.mapping, [mappingField]: e } });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.checkIfAllMapped()) {
      const fileMapping = {};
      _.each(this.state.mapping, (value, key) => {
        fileMapping[key] = value.id;
      });
      // console.log(fileMapping);
      const payload = {
        fileMapping,
        fileSource: 'body',
        fileType: 'csv',
        fileContent: this.props.fileContent,
        staticData: {
          amount: this.props.staticData.amount,
          paymentCategory: this.props.staticData.paymentCategory.id,
          paymentType: this.props.staticData.paymentType,
          dueConfig: this.props.staticData.dueConfig,
          seasonTag: this.props.staticData.seasonTag.id,
          activeAt: this.props.staticData.activeAt,
          planIdentifier: this.props.staticData.planIdentifier.id,
          ignoreIdentifier: this.props.staticData.ignoreIdentifier,
          descriptionPrefix: this.props.staticData.descriptionPrefix,
          competitionId: this.props.staticData.competition.id,
        },
      };
      // console.log(payload);
      this.props.actions.createPaymentEventImport(payload);
    }
    this.setState({ changed: false });
  };

  renderField = (field, selectOptions) => {
    const value = this.state.mapping[field.key];

    return (
      <div className="row" key={field.key}>
        <div className="col col-12 col-xl-10 col-lg-8">
          <div className="mapping-container">
            <Input
              name={`${field.key}-mapping`}
              key={`${field.key}1`}
              placeholder=""
              className={classnames(
                'mapping-value',
                {
                  valid: !_.isEmpty(value),
                },
                {
                  invalid:
                    _.isEmpty(value)
                    && this.state.initialMappingSet
                    && field.required,
                },
              )}
              value={field.name}
              readOnly="readOnly"
              onChange={() => {}}
            />
            <Isvg className="mapping-arrow" src={RightArrow} />
            <InputGroupBlock
              name={field.key}
              className="w-100 height-40"
              labelText={null}
              placeholder=""
              type="select"
              options={selectOptions}
              key={`${field.key}2`}
              errors={null}
              value={value}
              onChange={(e) => this.handleMappingChange(e, field.key)}
              readOnly="readOnly"
            />
          </div>
        </div>
      </div>
    );
  };

  renderMappingOptions = () => {
    const selectOptions = _.map(this.props.availableFields, (availableField) => ({
      id: availableField,
      name: availableField,
    }));
    const eventFields = _.filter(this.props.requiredFields, { type: 'event' });

    return [
      _.map(eventFields, (field) => this.renderField(field, selectOptions)),
    ];
  };

  render(): React.ReactNode {
    return (
      <SectionGroup title="3. Map CSV Data" className="" notification="">
        <div className="row">
          <div className="col">
            <div className="row">
              <div className="col col-12">
                <div className="form-description">
                  Map the fields from the provided file to the required fields
                  for the import:
                </div>
              </div>
            </div>
            <div className="row with-margin-top">
              <div className="col col-12">
                <div className="row">
                  <div className="col col-12 col-xl-10 col-lg-8 mapping-container mapping-header">
                    <Label className="mapping-heading">Event Data</Label>
                    <div className="mapping-spacer" />
                    <Label className="mapping-heading">
                      Column from CSV file
                    </Label>
                  </div>
                </div>
                {this.renderMappingOptions()}
              </div>
            </div>
            <div
              className={classnames('row', {
                'd-none': !this.checkIfAllMapped(),
              })}
            >
              <div className="col btn-flex-group less-padding">
                <div className="btn-flex-container">
                  <Button
                    className="btn-standard btn-1"
                    isLoading={this.props.paymentEventImports.isLoading}
                    type="submit"
                    onClick={this.handleSubmit}
                  >
                    Import
                  </Button>
                  <Button
                    onClick={() => history.push('/events')}
                    className="btn-standard btn-2"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionGroup>
    );
  }
}
